import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        According to Oskar Nummedal, one of Peak’s Data Science Team Leaders, the Peak platform and
        its applications improve efficiency and operations by telling FareShare GM which food
        donations should go to specific charity partners.
      </p>
      <p className="chapter__paragraph">
        One of these applications identifies which charity partners are most likely to take on
        certain types of food. “Having this intelligence will allow FareShare GM to reach out to
        those partners first in the case of large, unusual donations that need to be distributed
        quickly,” Nummedal says. “The application is designed to reduce waste and help the FareShare
        GM team spend more of their time where it is really needed.”
      </p>

      <p className="chapter__paragraph">
        Peak runs on{' '}
        <a
          href="https://aws.amazon.com/intel/"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          Amazon Web Services (AWS)
        </a>{' '}
        with{' '}
        <a
          href="https://www.intel.com/content/www/us/en/products/details/processors/xeon/scalable.html"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          3<sup>rd</sup> Gen Intel<sup>®</sup> Xeon<sup>®</sup> Scalable processors{' '}
        </a>{' '}
        to power its compute-intensive AI tasks that analyze mountains of data and produce
        actionable intelligence. “The whole infrastructure that underpins our deployment of AI
        applications is powered by AWS and Intel,” Nummedal says. “Building the platform was a big
        journey, and AWS has been with us providing support every step of the way.”
      </p>
    </section>
  );
}

export default Chapter5;
